/* @flow */

import { templateContainer, templateItem } from './style/template.style';
import { gridTemplate, gridStart } from 'src/shared/app/base/style/util/grid';

export default {
  root: {
    extend: templateContainer,

    // `auto` doesn't seem supported by IE11
    ...gridTemplate('1fr', '1fr'),
  },
  main: {
    extend: templateItem,

    ...gridStart(1, 1),
  },
};
